<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, BLOCK } from '#library/components.schema.build.ts'
	import Render from '#components/render.svelte'
	import Image from '#components/image.svelte'
	import Button from '#components/button.svelte'

	interface Props {
		blok: Blok<BLOCK>
	}

	let { blok }: Props = $props()
</script>

<div class="facility contain theme-crocus-on-light-gimson" {...attrs(blok)}>
	<Image src={blok.image.filename} alt={blok.title} aspect="4/3" />
	<div class="content">
		<div class="title">{blok.title}</div>
		<div class="body">
			<Render content={blok.body} />
		</div>
		<div class="buttons">
			{#if blok.link?.url}
				<Button href={blok.link.url} fill>{blok.link.text}</Button>
			{/if}
			<!-- <Button outline>Add to my enquiry</Button> -->
		</div>
	</div>
</div>

<style lang="css">
	.facility {
		align-items: center;
		background-color: var(--c-background);
		color: var(--c-foreground);
		display: grid;
		gap: 1.5rem;
		margin-block: 2.5rem;
		padding: 1.5rem;

		@media (--from-mobile) {
			gap: 2.5rem;
			grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
			padding: 3.5rem;
		}
	}

	.content {
		align-self: stretch;
		display: flex;
		flex-direction: column;
	}

	.title {
		font: 600 var(--f-h3);
		letter-spacing: var(--ls-h3);
	}

	.body {
		color: var(--c-midground);
		font: 400 var(--f-body1);
		letter-spacing: var(--ls-body1);
		margin-block-end: auto;
	}

	.buttons {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		margin-block-start: 1rem;

		@media (--from-mobile) {
			flex-direction: row;
		}
	}
</style>
